const RESPONSE_PATH = '/respuesta';

const RESPONSE_VIEW_PORTABILIDAD_OK = 'exito';
const RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_ASYNC = 'atencion-con-ejecutivo-2';
const RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_LOAN_ASYNC = 'atencion-con-ejecutivo-4';
const RESPONSE_VIEW_CONTACTO = 'atencion-con-ejecutivo-5';

const RESPONSE_VIEW_ERROR = 'error';
const RESPONSE_VIEW_LO_SENTIMOS_PORTABILIDAD = 'lo-sentimos-2';
const RESPONSE_VIEW_LO_SENTIMOS_LOAN = 'lo-sentimos-3';

const RESPONSE_VIEW_DOCUMENT_UPDATE_OK = 'documentos-ok';
const RESPONSE_VIEW_DOCUMENT_BK_UPDATE_OK = 'documentos-ok-bk';
const RESPONSE_VIEW_DOCUMENT_UPDATE_INCOMPLETE = 'documentos-incompleto';
const RESPONSE_VIEW_LO_SENTIMOS_RESIMULACION = 'lo-sentimos-4';

const RESPONSE_VIEW_AUTOATENCION_EXITO = 'autoatencion-exito';


export {
	RESPONSE_PATH,
	RESPONSE_VIEW_PORTABILIDAD_OK,
	RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_ASYNC,
	RESPONSE_VIEW_ERROR,
	RESPONSE_VIEW_LO_SENTIMOS_PORTABILIDAD,
	RESPONSE_VIEW_LO_SENTIMOS_LOAN,
	RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_LOAN_ASYNC,
	RESPONSE_VIEW_CONTACTO,
	RESPONSE_VIEW_DOCUMENT_UPDATE_OK,
	RESPONSE_VIEW_DOCUMENT_UPDATE_INCOMPLETE,
	RESPONSE_VIEW_LO_SENTIMOS_RESIMULACION,
	RESPONSE_VIEW_AUTOATENCION_EXITO,
	RESPONSE_VIEW_DOCUMENT_BK_UPDATE_OK
};
